const API_BASE = process.env.REACT_APP_BACKEND;

export const fetchBlogs = async () => {
  try {
    const response = await fetch(`${API_BASE}/api/getBlogs`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching blogs:', error);
    return [];
  }
};


export const fetchSingleBlog = async (id) => {
  try {
    const response = await fetch(`${API_BASE}/api/getBlog/${id}`);
    if (!response.ok) {
      throw new Error('Blog not found');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching blog:', error);
    throw error;
  }
};


export const fetchTestimonials = async () => {
  try {
    const response = await fetch(`${API_BASE}/api/getTestimonials`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching testimonials:', error);
    return [];
  }
};